<mat-tab-group>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="tab-label activity-list-tab">Activity List</span>
    </ng-template>
    <!-- Safety -->
    <tds-block mode-variant="primary">
      <h2>Safety</h2>
      <tds-table
        vertical-dividers="false"
        compact-design="false"
        responsive
        zebraMode="rows-odd"
        no-min-width
      >
        <tds-table-header>
          <tds-header-cell
            cell-key="activityName"
            cell-value="Activity Name"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="assignedBy"
            cell-value="Assigned By"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="openedDate"
            cell-value="Opened Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="targetDate"
            cell-value="Target Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="responsible"
            cell-value="Responsible"
          ></tds-header-cell>
        </tds-table-header>
        <tds-table-body
          #safetyDropList="cdkDropList" 
          cdkDropList
          cdkDropListId="safetyList"
          [cdkDropListData]="safetyList"
          [cdkDropListConnectedTo]="['qualityList']"
          (cdkDropListDropped)="drop($event)"
        >
          <tds-table-body-row *ngFor="let row of tableSafetyData" cdkDrag>
            <tds-body-cell cell-key="activityName">
              {{ row.name }}
            </tds-body-cell>
            <tds-body-cell cell-key="assignedBy">
              {{ row.assignedBy }}
            </tds-body-cell>
            <tds-body-cell cell-key="openedDate">
              {{ row.openDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="targetDate">
              {{ row.targetDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="responsible">
              {{ row.responsible }}
            </tds-body-cell>
          </tds-table-body-row>
        </tds-table-body>
        <tds-table-footer
          pagination
          [pages]="pagesSafetyList"
          (tdsPagination)="handlePaginationSafetyTable($event)"
          [rowsPerPageValues]="rowsPerPageValuesArray"
        ></tds-table-footer>
      </tds-table>
    </tds-block>
    <!-- Quality -->
    <tds-block mode-variant="primary">
      <h2>Quality</h2>
      <tds-table
        vertical-dividers="false"
        compact-design="false"
        responsive
        zebraMode="rows-odd"
        no-min-width
      >
        <tds-table-header>
          <tds-header-cell
            cell-key="activityName"
            cell-value="Activity Name"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="assignedBy"
            cell-value="Assigned By"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="openedDate"
            cell-value="Opened Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="targetDate"
            cell-value="Target Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="responsible"
            cell-value="Responsible"
          ></tds-header-cell>
        </tds-table-header>
        <tds-table-body
          #qualityDropList="cdkDropList" 
          cdkDropList
          cdkDropListId="qualityList"
          [cdkDropListData]="qualityList"
          [cdkDropListConnectedTo]="['safetyList']"
          (cdkDropListDropped)="drop($event)"
          >
          <tds-table-body-row *ngFor="let row of tableQualityData" cdkDrag>
            <tds-body-cell cell-key="activityName">
              {{ row.name }}
            </tds-body-cell>
            <tds-body-cell cell-key="assignedBy">
              {{ row.assignedBy }}
            </tds-body-cell>
            <tds-body-cell cell-key="openedDate">
              {{ row.openDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="targetDate">
              {{ row.targetDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="responsible">
              {{ row.responsible }}
            </tds-body-cell>
          </tds-table-body-row>
        </tds-table-body>
        <tds-table-footer
          pagination
          [pages]="pagesQualityList"
          (tdsPagination)="handlePaginationQualityTable($event)"
          [rowsPerPageValues]="rowsPerPageValuesArray"
        ></tds-table-footer>
      </tds-table>
    </tds-block>
    <!-- Assembly -->
    <tds-block mode-variant="primary">
      <h2>Assembly</h2>
      <tds-table
        vertical-dividers="false"
        compact-design="false"
        responsive
        zebraMode="rows-odd"
        no-min-width
      >
        <tds-table-header>
          <tds-header-cell
            cell-key="activityName"
            cell-value="Activity Name"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="assignedBy"
            cell-value="Assigned By"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="openedDate"
            cell-value="Opened Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="targetDate"
            cell-value="Target Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="responsible"
            cell-value="Responsible"
          ></tds-header-cell>
        </tds-table-header>
        <tds-table-body
          #assemblyDropList="cdkDropList" 
          cdkDropList
          cdkDropListId="assemblyList"
          [cdkDropListData]="assemblyList"
          [cdkDropListConnectedTo]="['qualityList']"
          (cdkDropListDropped)="drop($event)"
        >
          <tds-table-body-row *ngFor="let row of tableAssemblyData" cdkDrag>
            <tds-body-cell cell-key="activityName">
              {{ row.name }}
            </tds-body-cell>
            <tds-body-cell cell-key="assignedBy">
              {{ row.assignedBy }}
            </tds-body-cell>
            <tds-body-cell cell-key="openedDate">
              {{ row.openDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="targetDate">
              {{ row.targetDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="responsible">
              {{ row.responsible }}
            </tds-body-cell>
          </tds-table-body-row>
        </tds-table-body>
        <tds-table-footer
          pagination
          [pages]="pagesSafetyList"
          (tdsPagination)="handlePaginationAssemblyTable($event)"
          [rowsPerPageValues]="rowsPerPageValuesArray"
        ></tds-table-footer>
      </tds-table>
    </tds-block>
    <!-- Logistics -->
    <tds-block mode-variant="primary">
      <h2>Logistics</h2>
      <tds-table
        vertical-dividers="false"
        compact-design="false"
        responsive
        zebraMode="rows-odd"
        no-min-width
      >
        <tds-table-header>
          <tds-header-cell
            cell-key="activityName"
            cell-value="Activity Name"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="assignedBy"
            cell-value="Assigned By"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="openedDate"
            cell-value="Opened Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="targetDate"
            cell-value="Target Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="responsible"
            cell-value="Responsible"
          ></tds-header-cell>
        </tds-table-header>
        <tds-table-body
          #logisticsDropList="cdkDropList" 
          cdkDropList
          cdkDropListId="logisticsList"
          [cdkDropListData]="logisticsList"
          [cdkDropListConnectedTo]="['qualityList']"
          (cdkDropListDropped)="drop($event)"
        >
          <tds-table-body-row *ngFor="let row of tableLogisticsData" cdkDrag>
            <tds-body-cell cell-key="activityName">
              {{ row.name }}
            </tds-body-cell>
            <tds-body-cell cell-key="assignedBy">
              {{ row.assignedBy }}
            </tds-body-cell>
            <tds-body-cell cell-key="openedDate">
              {{ row.openDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="targetDate">
              {{ row.targetDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="responsible">
              {{ row.responsible }}
            </tds-body-cell>
          </tds-table-body-row>
        </tds-table-body>
        <tds-table-footer
          pagination
          [pages]="pagesLogisticsList"
          (tdsPagination)="handlePaginationLogisticsTable($event)"
          [rowsPerPageValues]="rowsPerPageValuesArray"
        ></tds-table-footer>
      </tds-table>
    </tds-block>
    <!-- Project -->
    <tds-block mode-variant="primary">
      <h2>Project</h2>
      <tds-table
        vertical-dividers="false"
        compact-design="false"
        responsive
        zebraMode="rows-odd"
        no-min-width
      >
        <tds-table-header>
          <tds-header-cell
            cell-key="activityName"
            cell-value="Activity Name"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="assignedBy"
            cell-value="Assigned By"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="openedDate"
            cell-value="Opened Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="targetDate"
            cell-value="Target Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="responsible"
            cell-value="Responsible"
          ></tds-header-cell>
        </tds-table-header>
        <tds-table-body
          #projectDropList="cdkDropList" 
          cdkDropList
          cdkDropListId="projectList"
          [cdkDropListData]="projectList"
          (cdkDropListDropped)="drop($event)"
        >
          <tds-table-body-row *ngFor="let row of tableProjectData" cdkDrag>
            <tds-body-cell cell-key="activityName">
              {{ row.name }}
            </tds-body-cell>
            <tds-body-cell cell-key="assignedBy">
              {{ row.assignedBy }}
            </tds-body-cell>
            <tds-body-cell cell-key="openedDate">
              {{ row.openDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="targetDate">
              {{ row.targetDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="responsible">
              {{ row.responsible }}
            </tds-body-cell>
          </tds-table-body-row>
        </tds-table-body>
        <tds-table-footer
          pagination
          [pages]="pagesProjectList"
          (tdsPagination)="handlePaginationProjectTable($event)"
          [rowsPerPageValues]="rowsPerPageValuesArray"
        ></tds-table-footer>
      </tds-table>
    </tds-block>
    <!-- SPCT -->
    <tds-block mode-variant="primary">
      <h2>SPCT</h2>
      <tds-table
        vertical-dividers="false"
        compact-design="false"
        responsive
        zebraMode="rows-odd"
        no-min-width
      >
        <tds-table-header>
          <tds-header-cell
            cell-key="activityName"
            cell-value="Activity Name"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="assignedBy"
            cell-value="Assigned By"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="openedDate"
            cell-value="Opened Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="targetDate"
            cell-value="Target Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="responsible"
            cell-value="Responsible"
          ></tds-header-cell>
        </tds-table-header>
        <tds-table-body
          #spctDropList="cdkDropList" 
          cdkDropList
          cdkDropListId="projectList"
          [cdkDropListData]="spctList"
          (cdkDropListDropped)="drop($event)"
        >
          <tds-table-body-row *ngFor="let row of tableSpctData" cdkDrag>
            <tds-body-cell cell-key="activityName">
              {{ row.name }}
            </tds-body-cell>
            <tds-body-cell cell-key="assignedBy">
              {{ row.assignedBy }}
            </tds-body-cell>
            <tds-body-cell cell-key="openedDate">
              {{ row.openDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="targetDate">
              {{ row.targetDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="responsible">
              {{ row.responsible }}
            </tds-body-cell>
          </tds-table-body-row>
        </tds-table-body>
        <tds-table-footer
          pagination
          [pages]="pagesSpctList"
          (tdsPagination)="handlePaginationSpctTable($event)"
          [rowsPerPageValues]="rowsPerPageValuesArray"
        ></tds-table-footer>
      </tds-table>
    </tds-block>
    <!-- General -->
    <tds-block mode-variant="primary">
      <h2>General</h2>
      <tds-table
        vertical-dividers="false"
        compact-design="false"
        responsive
        zebraMode="rows-odd"
        no-min-width
      >
        <tds-table-header>
          <tds-header-cell
            cell-key="activityName"
            cell-value="Activity Name"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="assignedBy"
            cell-value="Assigned By"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="openedDate"
            cell-value="Opened Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="targetDate"
            cell-value="Target Date"
          ></tds-header-cell>
          <tds-header-cell
            cell-key="responsible"
            cell-value="Responsible"
          ></tds-header-cell>
        </tds-table-header>
        <tds-table-body
          #generalDropList="cdkDropList" 
          cdkDropList
          cdkDropListId="generalList"
          [cdkDropListData]="generalList"
          (cdkDropListDropped)="drop($event)"
        >
          <tds-table-body-row *ngFor="let row of tableGeneralData" cdkDrag>
            <tds-body-cell cell-key="activityName">
              {{ row.name }}
            </tds-body-cell>
            <tds-body-cell cell-key="assignedBy">
              {{ row.assignedBy }}
            </tds-body-cell>
            <tds-body-cell cell-key="openedDate">
              {{ row.openDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="targetDate">
              {{ row.targetDate }}
            </tds-body-cell>
            <tds-body-cell cell-key="responsible">
              {{ row.responsible }}
            </tds-body-cell>
          </tds-table-body-row>
        </tds-table-body>
        <tds-table-footer
          pagination
          [pages]="pagesGeneralList"
          (tdsPagination)="handlePaginationGeneralTable($event)"
          [rowsPerPageValues]="rowsPerPageValuesArray"
        ></tds-table-footer>
      </tds-table>
    </tds-block>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="tab-label spct-tab">SPCT</span>
    </ng-template>
    SPCT
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="tab-label general-tab">General</span>
    </ng-template>
    GENERAL
  </mat-tab>
</mat-tab-group>